export const planetsAssets = [
  { name: '', src: 'planet.svg' },
  { name: 'Donlon', src: 'donlon.svg' },
  { name: 'Enchai', src: 'enchai.svg' },
  { name: 'Jebing', src: 'jebing.svg' },
  { name: 'Sapir', src: 'sapir.svg' },
  { name: 'Lerbin', src: 'lerbin.svg' },
  { name: 'Pingasor', src: 'pingasor.svg' } 
];

export const vehiclesAssets = [
  { name: '', src: 'vehicle.svg' },
  { name: 'Space pod', src: 'pod.svg' },
  { name: 'Space rocket', src: 'rocket.svg' },
  { name: 'Space shuttle', src: 'shuttle.svg' },
  { name: 'Space ship', src: 'ship.svg' }
];
